import React from 'react'
import { Box, Container, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';

const WrapperSection = ({ link, children, sx }) => {
  const themeM = useTheme();
  const isMobile = useMediaQuery(themeM.breakpoints.down('sm')); 
  return (
    <>
      <div id={link}>
        <Container maxWidth={'xl'} sx={{ '@media print': { maxWidth: '100% !important', padding: '0 !important' } }}>
          <Box sx={{ 
            my: { md: 2 ,xs:1}, 
            display: 'flex', 
            flexDirection: 'column', 
            gap: { md: 1.7, xs: 1 }, 
            position: 'relative', 
            zIndex: 11, 
            textAlign: isMobile && 'center',
            '@media print': {
              margin: '0 !important',
              padding: '0 !important',
              gap: '20px !important',
            },
            ...sx 
          }} >
            {children}
          </Box>
        </Container>
      </div>
    </>
  )
}

export default WrapperSection